module.exports = __webpack_public_path__ + "img/posticon.e0e18860.svg";